// Function for svg sprite
function requireAll(r) {
    r.keys().forEach(r);
}
requireAll(require.context('../images/sprite-images/', true, /\.svg$/));


//Modification comments 
const commentModerations = document.querySelectorAll('.comment-awaiting-moderation');

commentModerations.forEach(commentModeration => {
    commentModeration.parentElement.classList.add('comment-body--moderation');
})


////////////////// Animation Home  //////////////////

/* Afficher plus */
const classExists = document.getElementsByClassName('home').length > 0;

if (classExists) {

    //Animation button home events
    if (document.querySelector('.events__list__more')) {
        let buttonEvent = document.querySelector('.events__list__more')
        buttonEvent.addEventListener('click',function(){
            let heightContainerEvents = document.querySelector('.events__list')
            heightContainerEvents.classList.toggle('events__list--focus')
            buttonEvent.classList.toggle('events__list__more--focus')
            let buttonEventFocusExists = document.getElementsByClassName('events__list__more--focus').length > 0;
            if (buttonEventFocusExists){
                buttonEvent.setAttribute("title", "Afficher moins")
            }
            else {
                buttonEvent.setAttribute("title", "Afficher plus")
            }
        })
    }

}

//////////////////////// Parallax Home //////////////////////
if(window.innerWidth > 960){
    window.addEventListener('scroll', () => {

        /* Pour les images admin */

        // wh = Window Height = Hauteur de la fenêtre du navigateur
        const wH                = window.innerHeight
        // On récupère tous les éléments
        const workLinkOne        = document.querySelector('.admin-images__item--0');
        const workLinkTwo        = document.querySelector('.admin-images__item--1');
        const workLinkThree        = document.querySelector('.admin-images__item--2');
        const workLinkFour        = document.querySelector('.admin-images__item--3');
        const workLinkFive        = document.querySelector('.admin-images__item--4');

        // On récupère la distance qui sépare l'élément de la fenêtre du navigateur
        let workLinkPosOne           = workLinkOne.getBoundingClientRect().top;
        let workLinkPosTwo           = workLinkTwo.getBoundingClientRect().top;
        let workLinkPosThree         = workLinkThree.getBoundingClientRect().top;
        let workLinkPosFour           = workLinkFour.getBoundingClientRect().top;
        let workLinkPosFive           = workLinkFive.getBoundingClientRect().top;
        // On ajoute un délais pour déclencher l'animation avant que l'élément ne soit dans la fenêtre
        let workLinkOffset         =  300;

        /* Le calcul magique
        /* (wH - workLinkOffset) = Hauteur de la fenêtre - Le décalage positif (en dehors de la fenêtre) ou négatif (à l'intérieur de la fenêtre) = Le déclenchement de l'animation 
        /* workLinkOffset valeur positive = l'animation commmence en dehors de la fenêtre / valeur négative = l'animation commence dans la fenêtre / 0 = l'animation commence dès que l'élément entre dans la fenêtre
        /* workLinkPos = Position de l'élément par rapport à la fenêtre du browser que l'on divise par (wH - workLinkOffset) puis multiplié par 100 afin d'avoir le poucentage de l'animation en fonction de la position de l'élément dans la fenêtre
        /* et on redivise le résultat par 100 pour avoir une valeur de 0 à 1 (relatif à la durée de l'animation 1s)
        */

        workLinkCalcOne = ((workLinkPosOne / (wH + workLinkOffset)) * 100) / 100;
        workLinkCalcTwo = ((workLinkPosTwo / (wH + workLinkOffset)) * 100) / 100;
        workLinkCalcThree = ((workLinkPosThree / (wH + workLinkOffset)) * 100) / 100;
        workLinkCalcFour = ((workLinkPosFour / (wH + workLinkOffset)) * 100) / 100;
        workLinkCalcFive = ((workLinkPosFive / (wH + workLinkOffset)) * 100) / 100;

        // Si la valeur est comprise entre 0 et 1 l'animation est en court (ici -0.5 pour que ça continue un peu en dehors pour créer le décalage des images)
        if(workLinkCalcOne < 1 && workLinkCalcOne > -0.5) {
            /* document.body.style.setProperty('--workScroll-' + i, workLinkCalc ); */
            workLinkOne.style.top = workLinkPosOne * 0.1 + "px";
        }
        if(workLinkCalcTwo < 1 && workLinkCalcTwo > -0.5) {
            /* document.body.style.setProperty('--workScroll-' + i, workLinkCalc ); */
            workLinkTwo.style.top = workLinkPosTwo * 0.15 + "px";
        }
        if(workLinkCalcThree < 1 && workLinkCalcThree > -0.5) {
            /* document.body.style.setProperty('--workScroll-' + i, workLinkCalc ); */
            workLinkThree.style.top = workLinkPosThree * 0.25 + "px";
        }
        if(workLinkCalcFour < 1 && workLinkCalcFour > -0.5) {
            /* document.body.style.setProperty('--workScroll-' + i, workLinkCalc ); */
            workLinkFour.style.top = workLinkPosFour * 0.1 + "px";
        }
        if(workLinkCalcFive < 1 && workLinkCalcFive > -0.5) {
            /* document.body.style.setProperty('--workScroll-' + i, workLinkCalc ); */
            workLinkFive.style.top = workLinkPosFive * 0.2 + "px";
        }


        /* Pour les formes SVGs en arrière plan */
        // On récupère tous les éléments
        const aluShape                  = document.querySelector('.slideshow__shape');
        const eventsShape               = document.querySelector('.events__shape');
        const adminAreaShape            = document.querySelector('.admin-area__shape');
        const adminImagesShape          = document.querySelector('.admin-images__shape');
        
        // On récupère la distance qui sépare l'élément de la fenêtre du navigateur
        let aluPos                      = aluShape.getBoundingClientRect().top;
        let eventsPos                   = eventsShape.getBoundingClientRect().top;
        let adminAreaPos                = adminAreaShape.getBoundingClientRect().top;
        let adminImagesPos              = adminImagesShape.getBoundingClientRect().top;

        // On ajoute un délais pour déclencher l'animation avant que l'élément ne soit dans la fenêtre
        let svgOffset         =  100;

        //Le calcul magique 
        aluCalc = ((aluPos / (wH + svgOffset)) * 100) / 100;
        eventsCalc = ((eventsPos / (wH + svgOffset)) * 100) / 100;
        adminAreaCalc = ((adminAreaPos / (wH + svgOffset)) * 100) / 100;
        adminImagesCalc = ((adminImagesPos / (wH + svgOffset)) * 100) / 100;

        // Si la valeur est comprise entre 0 et 1 l'animation est en court 
        const aluShapeTop = -255;
        if(aluCalc < 1 && aluCalc > -0.5) {
            aluShape.style.top = aluPos * 0.2 + aluShapeTop + "px";
        }
        const eventsShapeTop = -135;
        if(eventsCalc < 1 && eventsCalc > 0) {
            eventsShape.style.top = eventsPos * 0.25 + eventsShapeTop + "px";
        }
        if(adminAreaCalc < 1 && adminAreaCalc > 0) {
            adminAreaShape.style.top = adminAreaPos * 0.1 + "px";
        }
        if(adminImagesCalc < 1.5 && adminImagesCalc > 0.5) {
            adminImagesShape.style.top = adminImagesPos * 0.2 + 70 + "px";
        }


    }, false);

}

//////////////////////// Footer menu //////////////////////
const footerMenuItems = document.querySelectorAll('.footer__menu__link')
    footerMenuItems.forEach((item) => {
        item.addEventListener('mouseenter',function(){
            item.classList.remove('active');
            footerMenuItems.forEach((item) => {
                item.classList.add('active');
            })
        })
        item.addEventListener('mouseleave',function(){
            item.classList.remove('active');
            footerMenuItems.forEach((item) => {
                item.classList.remove('active');
            })
        })
    })
